module.exports = __webpack_public_path__ + "static/springboardclinic-logo-f61c82d586fdac7ff0488857474f659a.jpeg";